import { onBeforeUnmount, readonly, ref, toValue, watch, type MaybeRefOrGetter } from 'vue'

/**
 * Open modal overlays — drawers, dialogs, sheets, the quiz layer, popovers with a mask.
 * One counter for the whole app: the page scroll stays locked until the last one closes
 * (PrimeVue's own `block-scroll` drops the lock when an inner overlay closes over an outer one),
 * and floating chrome (AIRA) hides while any overlay is up.
 */
const openCount = ref(0)

export const fairOverlayCount = readonly(openCount)

function syncScrollLock() {
  document.documentElement.classList.toggle('fair-overlay-open', openCount.value > 0)
}

/** Registers an overlay while `open` is true; releases it on close and on unmount. */
export function useFairOverlay(open: MaybeRefOrGetter<boolean>): void {
  let held = false

  function hold(next: boolean) {
    if (next === held || typeof document === 'undefined') return
    held = next
    openCount.value += next ? 1 : -1
    syncScrollLock()
  }

  watch(() => Boolean(toValue(open)), hold, { immediate: true })
  onBeforeUnmount(() => hold(false))
}
